import { Route, Switch } from "react-router-dom";

import Header from "components/Header";
import Footer from "components/Footer";
import Where from "components/Creation/components/Where";
import When from "components/Creation/components/When";
import What from "components/Creation/components/What";
import Anything from "components/Creation/components/Anything";
import Budget from "components/Creation/components/Budget";
import Confirm from "components/Creation/components/Confirm";
import BubblesBg from "components/BubblesBg";
import Charge from "components/Creation/components/Charge";
import Success from "components/Creation/components/Success";
import { useCorporateMode } from "context/CorporateModeContext";

const UserFacing = ({ path }) => {
  path = path || "/";
  const { isCorporate } = useCorporateMode();

  return (
    <div
      // style={{
      //   height: "100%",
      // }}
      className="md:h-[100%]"
    >
      {!isCorporate && <BubblesBg />}
      {/* <Header /> */}
      <Switch>
        <Route
          exact
          path={`${path}where`}
          render={() => {
            console.log("rendering Where from router");
            return <Where />;
          }}
        />
        <Route
          exact
          path={`${path}when`}
          render={() => {
            return <When />;
          }}
        />
        <Route
          exact
          path={`${path}what`}
          render={() => {
            return <What />;
          }}
        />
        <Route
          exact
          path={`${path}anything`}
          render={() => {
            return <Anything />;
          }}
        />
        <Route
          exact
          path={`${path}budget`}
          render={() => {
            return <Budget />;
          }}
        />
        <Route
          exact
          path={`${path}confirm`}
          render={() => {
            return <Confirm />;
          }}
        />
        <Route
          exact
          path={`${path}charge`}
          render={() => {
            return <Charge />;
          }}
        />
        <Route
          exact
          path={`${path}success`}
          render={() => {
            return <Success />;
          }}
        />
        <Route
          render={() => {
            return (
              <div>
                <h1>404</h1>
              </div>
            );
          }}
        />
      </Switch>
    </div>
  );
};

export default UserFacing;
